export const HEADER_CONTROL_WIDTH = 24;
export const HEADER_CONTROL_HEIGHT = 18;
export const HEADER_CONTROL_RADIUS = 4;

/** Breathing room around the icon that turns it into a pressable target. */
export const HEADER_CONTROL_PADDING = 4;

/** Radius of the pressable container, so its corners stay concentric with the icon's. */
export const HEADER_CONTROL_OUTER_RADIUS = HEADER_CONTROL_RADIUS + HEADER_CONTROL_PADDING;
